import { Component, computed, inject, input } from '@angular/core';
import { StyleSheetSpriteComponent } from '@features/styles/style-sheet-sprite/style-sheet-sprite.component';
import { StylesService, TSprite } from '@features/styles/styles.service';

@Component({
  selector: 'app-hud-icon-button',
  imports: [StyleSheetSpriteComponent],
  templateUrl: './hud-icon-button.component.html',
  styleUrl: './hud-icon-button.component.css',
})
export class HudIconButtonComponent {
  readonly _stylesService = inject(StylesService);

  icon = input<TSprite | string | undefined>();

  _icon = computed<{ type: 'sprite'; sprite: TSprite } | { type: 'img'; url: string } | { type: 'nothing' }>(() => {
    const icon = this.icon();

    if (typeof icon === 'string') {
      return { type: 'img', url: icon };
    }

    if (icon) {
      return { type: 'sprite', sprite: icon };
    }

    return { type: 'nothing' };
  });
}
